/** Inline SVG icons (stroke uses currentColor so CSS controls the tint). */

export const ICON_PLAY =
  '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"></path></svg>';

export const ICON_UNDO =
  '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14l-4-4 4-4"></path><path d="M5 10h9a5 5 0 0 1 0 10h-3"></path></svg>';

export const ICON_RESTART =
  '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7"></path><path d="M21 4v5h-5"></path></svg>';

export const ICON_SOUND_ON =
  '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4z"></path><path d="M16 9a4 4 0 0 1 0 6"></path><path d="M19 7a8 8 0 0 1 0 10"></path></svg>';

export const ICON_SOUND_OFF =
  '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H3v6h3l5 4z"></path><path d="M22 9l-5 5"></path><path d="M17 9l5 5"></path></svg>';

export const ICON_CHEVRON =
  '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>';

/**
 * The brand mark: a blue rounded square holding a 2×2 of mini discs
 * (red / yellow / yellow / red). Built from elements so CSS styles each dot.
 */
export function logoMarkHtml(size: 'lg' | 'md' | 'sm' = 'md'): string {
  return `
    <span class="logo-mark logo-mark--${size}" aria-hidden="true">
      <span class="logo-dot logo-dot--red"></span>
      <span class="logo-dot logo-dot--yellow"></span>
      <span class="logo-dot logo-dot--yellow"></span>
      <span class="logo-dot logo-dot--red"></span>
    </span>`;
}
